export default function () {
  return {
    categories: [],
    loading: false,
  }
}
